import { AutogenModelTopmatch, AutogenRowTopmatch } from "./autogen/AutogenModelTopmatch";

export class ModelTopmatch extends AutogenModelTopmatch<RowTopmatch> {
    constructor() {
        super(RowTopmatch);
    }
}

export class RowTopmatch extends AutogenRowTopmatch {
}